import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { TestContent } from './models/TestContent.model';

export class TestsDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return TestContent.fromDto(dto) as any;
  }
}
